// extracted by mini-css-extract-plugin
export default {"container":"NavbarModule_container__+5Gz2","img":"NavbarModule_img__OXR2c"};